<template>
  <div class="container">
    <div class="row agenda-cards">
      <div class="col-lg-4">
        <div class="profile-info-card card">
          <div class="profile-info">
            <div class="info">
              <p class="name">{{ fullName }}</p>
              <p class="email">{{ profile.email }}</p>
              <p class="school" :key=school.id v-for="school in userSchools">{{ school.name }}</p>
            </div>
            <IconButton v-on:clicked="editProfileClicked" class="edit-profile-button"
                        iconName="fas fa-edit"></IconButton>
          </div>
          <v-button class="change-password-button" buttonText="Wachtwoord wijzigen" v-on:clicked="changePasswordClicked"
                    :enabled="true"></v-button>
          <div class="profile-summary">
            <p class="title">Samenvatting</p>
            <div class="summary-item">
              <p class="font-weight-bold">Actieve beweegbuddies</p>
              <p>{{ buddySummary.activeBuddies }}</p>
            </div>
            <div class="divider"></div>
            <div class="summary-item">
              <p class="font-weight-bold">Totaal beweegbuddies</p>
              <p>{{ buddySummary.totalBuddies }}</p>
            </div>
            <div class="divider"></div>
            <div class="summary-item">
              <p class="font-weight-bold">Geplande activiteiten</p>
              <p>{{ buddySummary.plannedActivities }}</p>
            </div>
            <div class="divider"></div>
            <div class="summary-item">
              <p class="font-weight-bold">Afgeronde activiteiten</p>
              <p>{{ buddySummary.completedActivities }}</p>
            </div>
            <div class="divider"></div>
          </div>

          <a class="delete-button" href="#" v-on:click.prevent="deleteAccountClicked">Account verwijderen</a>
        </div>
      </div>

      <div class="col-lg-4">
        <div class="active-buddies-card card">
          <p class="title">Actieve beweegbuddies</p>
          <div class="buddies-wrapper">
            <BuddySelectButton :key="buddy.id" v-for="buddy in activeBuddies" :buddy="buddy"
                               @clicked="buddyClicked" :interactable="true"></BuddySelectButton>
          </div>
          <IconTextButton iconName="fas fa-plus" buttonText="Buddy aanmaken"
                          @clicked="addBuddyButtonClicked"></IconTextButton>
        </div>
      </div>

      <div class="col-lg-4 mb-5">
        <div class="previous-year-card card" v-if="inactiveBuddies.length > 0">
          <p class="title">Vorig schooljaar</p>
          <div class="buddies-wrapper">
            <BuddySelectButton :key="buddy.id" v-for="buddy in inactiveBuddies" :buddy="buddy"></BuddySelectButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconButton from "@/components/UI/IconButton";
import VButton from "@/components/UI/VButton";
import IconTextButton from "@/components/UI/IconTextButton";
import BuddySelectButton from "@/components/Common/BuddySelectButton";
import log from "@/utils/logger";
import { BuddyApi, SchoolApi, UserApi } from "sandpiper_api";
import AuthMixin from "@/mixins/AuthMixin";

export default {
  name: "Profile",
  components: { IconButton, VButton, IconTextButton, BuddySelectButton },
  mixins: [ AuthMixin ],
  inject: [ "doApiRequest" ],
  data()
  {
    return {
      fetchingProfile: false,
      profile: {},
      fetchingBuddies: false,
      buddies: [],
      userSchools: [],
      fetchingBuddySummary: false,
      buddySummary: {}
    }
  },
  computed: {
    fullName()
    {
      if(this.profile)
      {
        return this.profile.firstName + " " + this.profile.lastName;
      }

      return "";
    },
    activeBuddies()
    {
      return this.buddies;
    },
    inactiveBuddies()
    {
      return [];
    }
  },
  methods: {
    editProfileClicked()
    {
      this.$router.push({ name: 'edit-profile', params: {
        initialFirstName: this.profile.firstName,
        initialLastName: this.profile.lastName,
        initialEmail: this.profile.email
      }});
    },
    changePasswordClicked()
    {
      this.$router.push({ name: 'change-password' });
    },
    deleteAccountClicked()
    {
      this.$router.push({ name: 'delete-profile' });
    },
    addBuddyButtonClicked()
    {
      this.$router.push({ name: 'create-buddy' });
    },
    buddyClicked(buddy)
    {
      this.$router.push({ name: 'buddy-detail', params: { id: buddy.id } });
    },
    async fetchUserProfile()
    {
      try
      {
        log.info("Fetching user profile");
        this.fetchingProfile = true;
        this.profile = await this.doApiRequest(() => new UserApi().getCurrentUser());
      }
      catch (e)
      {
        // TODO - handle error
        log.error("Failed to fetch profile - %o", e);
      }
      finally
      {
        this.fetchingProfile = false;
      }
    },
    async fetchBuddies()
    {
      try
      {
        log.info("Fetching buddies");
        this.fetchingBuddies = true;

        this.buddies = [];
        this.buddies = await this.doApiRequest(() => new BuddyApi().getBuddies());
      }
      catch (e)
      {
        // TODO - handle error
        log.error("Failed to fetch buddies - %o", e);
      }
      finally
      {
        this.fetchingBuddies = false;
      }
    },
    async fetchUserBuddySummary()
    {
      try
      {
        log.info("Fetching buddy summary for user [%s]", this.currentUserId);
        log.info(this.$store.state);
        log.info(this.isAuthenticated);
        this.fetchingBuddySummary = true;
        this.buddySummary = await this.doApiRequest(() => new UserApi().getUserBuddySummary(this.currentUserId));
      }
      catch (e)
      {
        // TODO - handle error
        this.buddySummary = {};
        log.error("Failed to fetch buddy summary - %o", e);
      }
      finally
      {
        this.fetchingBuddySummary = false;
      }
    },
    async fetchUserSchools()
    {
      try
      {
        this.fetchingUserSchools = true;
        this.userSchools = await this.doApiRequest(() => new SchoolApi().getCurrentUserSchools());
      }
      catch (e)
      {
        log.error("Failed to fetch user schools - %o", e);
      }
      finally
      {
        this.fetchingUserSchools = false;
      }
    },
  },
  created()
  {
    this.fetchUserProfile();
    this.fetchBuddies();
    this.fetchUserBuddySummary();
    this.fetchUserSchools();
  }
}
</script>

<style lang="scss" scoped>
.agenda-cards
{
  align-items: flex-start;
}

.card
{
  background-color: white;
  border-radius: 5px;
  box-shadow: $default-shadow;
  padding: 25px;
  margin-top: 25px;

  .title
  {
    font-size: 1rem;
    font-weight: bold;
    margin-bottom: 0.3rem;
  }

  .subtitle
  {
    font-size: 1rem;
    font-style: italic;
    margin-bottom: 0.3rem;
  }
}

.profile-info
{
  display: flex;

  .info {
    flex: 7 7;
    font-size: $body-text-size;

    .name, .email, .school {
      margin-bottom: 0px;
    }

    .name {
      font-weight: bold;
    }
  }

  .btn
  {
  }
}

.profile-summary
{
  margin-top: 50px;
}

.summary-item
{
  display: flex;
  justify-content: space-between;
  font-size: $body-text-size;
  padding: 16px 0px;

  p
  {
    margin-bottom: 0px;
  }
}

.divider
{
  height: 2px;
  background-color: $font-grey;
}

.change-password-button
{
  margin-top: 25px;
}

.delete-button
{
  color: $activity-orange;
  font-weight: bold;
  margin-top: 25px;
  align-self: center;
}

.buddies-wrapper .buddy-select-button
{
  margin-bottom: 16px;
}
</style>